import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!

  return (_openBlock(), _createBlock(_component_multiselect, {
    "track-by": "country",
    label: "value",
    placeholder: "",
    "show-labels": false,
    options: _ctx.phonePrefixes,
    searchable: false,
    "close-on-select": true,
    multiple: false,
    "allow-empty": true
  }, {
    singleLabel: _withCtx(({ option }) => [
      _createElementVNode("span", {
        class: _normalizeClass('flag-' + option.country)
      }, null, 2),
      _createTextVNode(),
      _createElementVNode("span", null, _toDisplayString(option.value), 1)
    ]),
    option: _withCtx(({ option }) => [
      _createElementVNode("span", {
        class: _normalizeClass('flag-' + option.country)
      }, null, 2),
      _createTextVNode(),
      _createElementVNode("span", null, _toDisplayString(option.value), 1)
    ]),
    _: 1
  }, 8, ["options"]))
}